import { IMessage } from '@eventr/common'
import {
    ColoursObj,
    drawerStore,
    MobileDrawerFrame,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { Emoji } from 'emoji-picker-react'
import { FC } from 'react'
import { isConnectivityAvailable } from '../../../connectivity/connectivityListener'
import { getEmojiUnifiedFromRocketName } from '../../emoji/emojiFuncs'
import { useRocketChatContext } from '../../rocketChatProvider'
import { MessageActionSheetBody } from '../actionSheet/messageActionSheetBody'
import { useChatBodyContext } from '../chatProvider'

interface IMessageReactionsProps {
    message: IMessage
}

export const MessageReactions: FC<IMessageReactionsProps> = ({ message }) => {
    const { getDownloadUrl } = useChatBodyContext()
    const { rcUserInfo } = useRocketChatContext()
    const reactions = message.reactions

    if (!reactions) {
        return null
    }

    const totalNumberOfReacts = () => {
        if (!reactions) {
            return 0
        }

        let numberReacts = 0

        Object.keys(reactions).forEach((reactionKey) => {
            if (reactions[reactionKey] && reactions[reactionKey].usernames) {
                numberReacts += reactions[reactionKey].usernames.length
            }
        })

        return numberReacts
    }

    return (
        <Box
            display={'grid'}
            gridAutoFlow={'column'}
            width={'fit-content'}
            sx={{
                backgroundColor: ColoursObj.backgrounds.secondary,
                borderRadius: '4px',
            }}
            padding={'4px 6px'}
            justifySelf={
                rcUserInfo &&
                message.u &&
                message.u._id &&
                rcUserInfo?._id === message.u._id
                    ? 'end'
                    : 'start'
            }
            onClick={() => {
                if (isConnectivityAvailable.value) {
                    drawerStore().openDrawer({
                        node: (
                            <MobileDrawerFrame>
                                {rcUserInfo && (
                                    <MessageActionSheetBody
                                        message={message}
                                        getDownloadUrl={
                                            getDownloadUrl ?? (() => {})
                                        }
                                        rcUserInfo={rcUserInfo}
                                    />
                                )}
                            </MobileDrawerFrame>
                        ),
                        onBackdropClick: () => {
                            drawerStore().closeDrawer()
                        },
                    })
                }
            }}
        >
            {Object.keys(reactions).map((reactionName, indexReaction) => {
                const numberOfReacts = () => {
                    try {
                        if (
                            reactions &&
                            reactions[reactionName] &&
                            reactions[reactionName].usernames
                        ) {
                            return reactions[reactionName].usernames.length
                        }
                        return 0
                    } catch {
                        return 0
                    }
                }

                if (numberOfReacts() < 1 || indexReaction > 4) {
                    return null
                }

                return (
                    <Typography
                        key={reactionName}
                        variant="bodySubtext"
                        padding={`0 ${
                            totalNumberOfReacts() > 1 ? '4px' : '0'
                        } 0 0`}
                    >
                        <Emoji
                            unified={
                                getEmojiUnifiedFromRocketName(reactionName) ??
                                ''
                            }
                            size={16}
                        />
                    </Typography>
                )
            })}
            <Typography variant="bodySubtext" color={ColoursObj.font.secondary}>
                {totalNumberOfReacts() > 1 ? totalNumberOfReacts() : ''}
            </Typography>
        </Box>
    )
}
